import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { Button } from 'react-bootstrap';
import { pushTvSalesStages } from '../../SetupActions';
import CollectorIndicator from '../TruVoiceTagsPage/CollectorIndicator';

class TruVoiceStageHistoriesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      submitted: false,
      submittedId: null,
      submittedCollectors: [],
    };
    this.start = this.start.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  start() {
    this.setState({ submitted: false, loading: true, submittedId: null, submittedCollectors: [] }, () => {
      this.props.dispatch(pushTvSalesStages())
        .then(
          (results) => {
            this.setState({ submitted: true, loading: false, submittedId: results.id, submittedCollectors: results.collectors });
          },
          (errors) => {
            const message = errors.data ? errors.data.message : 'Unknown error';
            const el = (<div>{message}</div>);
            this.context.addNotification(el, { type: 'error', autoClose: false });
            this.setState({ loading: false });
          },
        );
    });
  }

  handleError(message) {
    this.setState({
      submitted: false,
      submittedId: null,
      submittedCollectors: [],
    }, () => {
      const el = (<div>{message}</div>);
      this.context.addNotification(el, { type: 'error', autoClose: false });
    });
  }

  renderInstruction() {
    return (
      <div className="well">
        <p>
        Update opportunities that have been previously submitted to TruVoice with current CRM data. If the opportunity in TruVoice has an accurate CRM Opportunity ID, this process will update the following data for the opportunity in TruVoice:
        </p>
        <ul>
          <li>Sales Stage History</li>
          <li>
            Original Outcome
            <ul><li><em>Note: TruVoice updates an opportunity's outcome based on buyer feedback and stores the original CRM outcome as identified by the sales rep when the opportunity was closed.</em></li></ul>
          </li>
          <li>
            Opportunity Amount
            <ul><li><em>Note: This will update opportunity amounts in TruVoice based on the current opportunity amount settings and currency conversion settings enabled in TruVoice Automation.</em></li></ul>
          </li>

          <li>Opportunity Creation &amp; Close Dates</li>
          <li>Sales Rep (aka Opportunity Owner)</li>
          <li>Account Manager (aka Account Owner)</li>
          <li>Custom Fields</li>
        </ul>
        <p>
          As additional features are added to TruVoice that require specific CRM data (usually CRM IDs), use this feature to keep previously submitted opportunities up to date with correct and required CRM data.
        </p>
      </div>
    );
  }

  renderControls() {
    const { loading } = this.state;
    return (
      <Button disabled={loading} bsStyle="primary" onClick={this.start}>
        {!loading && <span>Update</span>}
        {loading && <span><Fa name="spinner" spin /> Updating</span>}
      </Button>
    );
  }

  renderResults() {
    const { submittedCollectors, submittedId } = this.state;
    return (
      <div>
        {submittedCollectors.map((submittedCollector) => {
          return (
            <CollectorIndicator
              key={`${submittedCollector.program_id}::${submittedCollector.collector_id}::${submittedCollector.collector_type}`}
              eventName={`tvPushStages::${submittedId}`}
              collector={submittedCollector}
              onError={this.handleError}
            />
          );
        })}
      </div>
    )
  }

  render() {
    const { submitted } = this.state;
    return (
      <div className="container">
        <Helmet title="Update TruVoice Data" />
        {this.renderInstruction()}
        {!submitted && this.renderControls()}
        {submitted && this.renderResults()}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

TruVoiceStageHistoriesPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

TruVoiceStageHistoriesPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};


export default withRouter(connect(mapStateToProps)(TruVoiceStageHistoriesPage));
